module.exports = __webpack_public_path__ + "static/media/erp-business-1.fa0b9c15.png";